<template>
  <div class="flex-auto flex justify-center items-center mx-auto">
    <div class="bg-white shadow-xl">

        <div class="bg-gray-600 text-white p-4 text-lg font-bold">
          Endre bruker
        </div>

        <form @submit.prevent="doSubmit" class="p-10" v-if="user">

          <div class="flex items-center justify-between mt-6">
            <label for="firstName" class="font-bold">Navn</label>
            <input type="text" id="firstName" v-model="user.name" ref="name" class="ml-6 w-64" required :class="{'invalid': errors.Name }">
          </div>

          <div class="flex items-center justify-between mt-6">
            <label for="email" class="font-bold">E-post</label>
            <input type="text" id="email" v-model="user.email" class="ml-6 w-64" required :class="{'invalid': errors.Email }">
          </div>

          <div class="flex items-center justify-between mt-6">
            <label for="phone" class="font-bold">Telefon</label>
            <input type="text" id="phone" v-model="user.phone" class="ml-6 w-64" :class="{'invalid': errors.Phone }">
          </div>

          <div class="flex items-center justify-between mt-6">
            <label class="font-bold">Rolle</label>
            <select v-model="user.role">
              <option value="0">Administrator</option>
              <option value="1">Praksiskoordinator</option>
              <option value="2">Apotekkontakt</option>
              <option value="3">Kjedekontakt</option>
            </select>
          </div>

          <!-- <div class="flex items-center justify-between mt-6">
            <label class="font-bold">Tilhørighet</label>
            Lookup
          </div> -->

          <div class="text-center mt-12">
            <button type="submit" class="btn btn-primary mx-2">Lagre</button>
            <router-link class="btn mx-2" to="/af/brukere">Avbryt</router-link>
          </div>

        </form>

    </div>
  </div>
</template>

<script>
import api from '@/api'
export default {
  name: 'ap-user-edit',
  props: {
    id: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      errors: [],
      user: null
    }
  },
  methods: {
    async doSubmit () {
      const response = await api.af.updateUser(this.user)
      if (response.errors) {
        this.errors = response.errors
      } else {
        this.$router.push('/af/brukere')
        this.$toasted.show('Bruker lagret!')
      }
    }
  },
  async mounted () {
    this.user = await api.af.getUser(this.id)
    this.$nextTick(() =>  this.$refs.name.focus()) // ref in inside a v-if'
  }
}
</script>

